<template>
  <div>
    <Collapse v-model="value" simple style="border: 0; margin-bottom: 30px">
      <Panel
        name="1"
        hide-arrow
        style="margin: 20px 0; border: 0"
        v-show="midType.includes('绩效重点')"
      >
        <FormTitle
          :titleText="$t('Performance_Priorities_WHAT_')"
        /><!-- 绩效重点(WHAT) -->
        <div slot="content" style="margin-top: 20px">
          <div v-show="midType.includes('绩效重点')">
            <!-- 绩效重点(WHAT) -->{{ $t("Performance_Priorities_WHAT_") }}
          </div>
          <PersonalGoals
            v-show="midType.includes('绩效重点')"
            ref="PersonalGoals"
            :tabName="'midTermReview'"
          ></PersonalGoals>
        </div>
      </Panel>
      <Panel
        name="5"
        hide-arrow
        style="margin: 20px 0; border: 0"
        v-show="midType.includes('STI')"
      >
        <FormTitle :titleText="$t('STI_Self')" /><!--STI个人目标  -->
        <div slot="content" style="margin-top: 20px">
          <div><!-- STI个人目标 -->{{ $t("STI_Self") }}</div>
          <STIComponent
            v-show="midType.includes('STI')"
            ref="STIComponent"
            :tabName="'midTermReview'"
          ></STIComponent>
        </div>
      </Panel>
      <Panel
        name="2"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="midType.includes('行为期望')"
      >
        <FormTitle
          :titleText="$t('Behavioural_Expections_How_')"
        /><!-- 行为期望(HOW) -->
        <div style="margin-top: 30px" slot="content">
          <BehaviorExpectation
            ref="BehaviorExpectation"
            :tabName="'midTermReview'"
          ></BehaviorExpectation>
        </div>
      </Panel>
      <Panel
        name="6"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="midType.includes('增长文化')"
      >
        <FormTitle
          :titleText="$t('Behavioural_Expections_How_')"
        /><!-- 增长文化 -->
        <div style="margin-top: 30px" slot="content">
          <GrowthCulture
            ref="GrowthCulture"
            :tabName="'midTermReview'"
          ></GrowthCulture>
        </div>
      </Panel>
      <Panel
        name="3"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="midType.includes('个人发展计划')"
      >
        <FormTitle :titleText="$t('longText11')" />
        <!-- 员工发展计划（需要考虑与3A行为准则或专业技能的差距，基于70/20/10原则，并根据实际情况进行填写发展行动中的在岗培训和经验/向他人学习/正式领导培训/正式业务培训/其他） -->
        <div slot="content" style="margin-top: 20px">
          <div><!-- 个人发展计划 -->{{ $t("Development_Plans") }}</div>
          <div style="margin-top: 30px" slot="content">
            <DevelopmentPlan
              ref="DevelopmentPlan"
              :tabName="'midTermReview'"
            ></DevelopmentPlan>
          </div>
        </div>
      </Panel>
      <Panel
        name="4"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="userInfoa.id"
      >
        <FormTitle
          :titleText="$t('Approval_History') + '/' + $t('Action_History')"
        /><!-- 审批历史/操作履历 -->
        <div style="margin-top: 30px" slot="content">
          <Tabs type="card" v-model="panel4value" name="sub-tabs">
            <TabPane
              :label="$t('Approval_History')"
              name="审批历史"
              tab="sub-tabs"
              :index="1"
              ><!-- 审批历史 -->
              <ApprovalHistory
                ref="ApprovalHistory"
                @pageChangeApproval="pageChangeApproval"
              ></ApprovalHistory>
            </TabPane>
            <TabPane
              :label="$t('Action_History')"
              name="操作履历"
              tab="sub-tabs"
              :index="2"
              ><!-- 操作履历 -->
              <OperationHistory
                ref="OperationHistory"
                @pageChangeOperation="pageChangeOperation"
              ></OperationHistory>
            </TabPane>
          </Tabs>
        </div>
      </Panel>
    </Collapse>
    <div class="btnRight" style="padding-top: 20px" v-if="cardHid">
      <!-- <Button type="primary" class="btn" v-if="applyEditFlag=='0'||applyEditFlag=='2'" @click="importCG">{{$t('Import_Draft')}}</Button> -->
      <!-- <Button type="primary" class="btn" v-if=" applyEditFlag=='0'||applyEditFlag=='2'" @click="saveCG">{{$t('Save_Draft')}}</Button> -->
      <Button
        type="primary"
        class="btn"
        v-if="
          (applyEditFlag == '0' || applyEditFlag == '2') && userDeptFlag != '10'
        "
        @click="submit"
        >{{ $t("saveandsubmit")
        }}<!-- 提交 --></Button
      >
      <!-- <Button type="primary" class="btn" v-if="!isHistory"  @click="QAClick">{{$t('Q&A')}}</Button> -->
      <Button
        type="primary"
        class="btn"
        v-if="isHistory && returnFlag"
        @click="returnApply"
        >{{ $t("Return")
        }}<!-- 返回 --></Button
      >
      <Button
        type="primary"
        class="btn"
        v-if="!isHistory && targetRevisionState"
        @click="targetRevision"
        >{{ $t("Objective_Revision")
        }}<!-- 目标修订 --></Button
      >
    </div>
    <!-- (applyEditFlag!='1' || (userDeptFlag=='3' || userDeptFlag=='4' || userDeptFlag=='2')) -->
    <Spin size="large" fix v-if="spinShow"></Spin>

    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />

    <QAComponent ref="qaComponent"></QAComponent>
  </div>
</template>

<script>
import PersonalGoals from "./PersonalGoals";
import STIComponent from "./STIComponent";
import BehaviorExpectation from "./BehaviorExpectation";
import GrowthCulture from "./GrowthCulture";
import DevelopmentPlan from "./DevelopmentPlan";
import axios from "axios";
import QAComponent from "@/components/process/Apply/components/QAComponent";
import ApprovalHistory from "./ApprovalHistory";
import OperationHistory from "./OperationHistory";
export default {
  components: {
    PersonalGoals,
    STIComponent,
    BehaviorExpectation,
    DevelopmentPlan,
    QAComponent,
    ApprovalHistory,
    OperationHistory,
    GrowthCulture,
  },
  data() {
    return {
      value: [1, 2, 3, 4, 5, 6],
      isHistory: false,
      userInfo: {},
      userInfoa: {},
      spinShow: false,
      reportId: "",
      userDeptFlag: "",
      applyEditFlag: "",
      qaId: "",
      midType: "",
      panel4value: "审批历史",
      cardHid: true,
      targetUpdateButton: "",
      targetRevisionState: true,
      returnFlag: false,
    };
  },
  watch: {
    userInfo(newVal, oldVal) {
      this.userInfoa = newVal;
    },
  },
  computed: {
    butCheck() {
      let value = false;
      if (this.beApprovalFlag == "0") {
        value = true;
        if (
          this.applyEditFlag != "1" ||
          (this.userDeptFlag == "3" &&
            this.userDeptFlag == "4" &&
            this.userDeptFlag == "2")
        ) {
          value = true;
        }
      } else if (this.beApprovalFlag == "2") {
        value = true;
        if (
          this.applyEditFlag != "1" ||
          (this.userDeptFlag == "3" &&
            this.userDeptFlag == "4" &&
            this.userDeptFlag == "2")
        ) {
          value = true;
        }
      } else {
        value = false;
      }
      return value;
    },
    //2026新内容是否生效
    isNCTE() {
      let flag = false;
      let nowDate = this.$nowDate.dateVal(new Date(), "YYYY");
      if (nowDate <= this.userInfo.year) {
        flag = true;
      }
      return flag;
    },
  },
  created() {},
  mounted() {},
  methods: {
    getData() {
      this.spinShow = true;
      axios
        .post("/achApply/selectApplyDetails", {
          achStage: "阶段回顾",
          id: this.reportId,
          serialnumber: this.userInfoa.serialnumber,
          year: this.userInfoa.year,
        })
        .then((res) => {
          this.spinShow = false;

          // 1修订 2 设定
          if (res.targetUpdateFlag != "1" && res.targetUpdateFlag != "2") {
            // 状态为3 开始定时提醒
            if (
              (res.applyAchInfo.status == "2" ||
                res.applyAchInfo.status == "3") &&
              (res.flagMap.userDeptFlag == "1" ||
                res.flagMap.userDeptFlag == "2" ||
                res.flagMap.userDeptFlag == "3" ||
                res.flagMap.userDeptFlag == "4")
            ) {
              this.$emit("beginTime", "1");
            } else {
              this.$emit("beginTime", "0");
            }
            this.midType = res.applyAchInfo.midType;
            this.$refs.PersonalGoals.data1 = res.achKeyNoteInfoList;
            this.$refs.PersonalGoals.getMidData();
            this.$refs.STIComponent.data1 = res.stiTargetInfoList;
            let list = res.expectInfoList;
            let array = [];
            if (list.length > 0) {
              this.$refs.BehaviorExpectation.data5.forEach((element) => {
                list.forEach((item) => {
                  if (element.criterionType == item.criterionType) {
                    array.push({ ...element, ...item });
                  }
                });
              });
              this.$refs.BehaviorExpectation.data5 = array;
              this.$refs.BehaviorExpectation.oldData = array;
            }
            // 2025追加增长文化
            let growthlist = res.growthCultureList;
            let growthArray = [];
            if (growthlist.length > 0) {
              this.$refs.GrowthCulture.data5.forEach((element) => {
                growthlist.forEach((item) => {
                  if (element.criterionType == item.criterionType) {
                    growthArray.push({ ...element, ...item });
                  }
                });
              });
              this.$refs.GrowthCulture.data5 = growthArray;
              this.$refs.GrowthCulture.oldData = growthArray;
              this.setGrowthCultureData();
            }

            this.$refs.DevelopmentPlan.data5 = res.developmentPlanList;
            res.applyAchInfo.empCode ? (this.userInfoa = res.applyAchInfo) : "";
            res.applyAchInfo.status
              ? (this.userInfoa.status = res.applyAchInfo.status)
              : "";
            this.$refs.PersonalGoals.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.STIComponent.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.BehaviorExpectation.applyEditFlag =
              res.flagMap.applyEditFlag;
            this.$refs.DevelopmentPlan.applyEditFlag =
              res.flagMap.applyEditFlag;
            // 2025 追加传入 增长文化赋值字段
            this.$refs.GrowthCulture.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.PersonalGoals.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.STIComponent.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.BehaviorExpectation.userDeptFlag =
              res.flagMap.userDeptFlag;
            this.$refs.DevelopmentPlan.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.GrowthCulture.userDeptFlag = res.flagMap.userDeptFlag;
            this.targetUpdateButton = res.flagMap.targetUpdateButton;
            this.userDeptFlag = res.flagMap.userDeptFlag;
            this.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.PersonalGoals.oldData = JSON.parse(
              JSON.stringify(this.$refs.PersonalGoals.data1)
            );
            this.$refs.STIComponent.oldData = JSON.parse(
              JSON.stringify(this.$refs.STIComponent.data1)
            );
            this.$refs.DevelopmentPlan.oldData = JSON.parse(
              JSON.stringify(this.$refs.DevelopmentPlan.data5)
            );
            if (res.applyAchInfo.id) {
              this.getApprovalData();
              this.getOperationData();
            }
          } else {
            this.$Modal.warning({
              title:
                res.targetUpdateFlag == "1"
                  ? this.$t("warningFinesh1")
                  : this.$t("warningFinesh2"),
              onOk: () => {
                this.$emit("addModalWarning");
              },
            });
          }
        });
    },
    setGrowthCultureData() {
      if (!this.isNCTE && this.$refs.GrowthCulture.data5.length > 0) {
        let allExpectDetails = "";
        let allEmpDetails = "";
        let allIndirSupFeedback = "";
        let allDirSupFeedback = "";
        this.$refs.GrowthCulture.data5.map((item) => {
          if (item.expectDetails) {
            allExpectDetails += item.expectDetails + ";\n";
          }
          if (item.empDetails) {
            allEmpDetails += item.empDetails + ";\n";
          }
          if (item.indirSupFeedback) {
            allIndirSupFeedback += item.indirSupFeedback + ";\n";
          }
          if (item.dirSupFeedback) {
            allDirSupFeedback += item.dirSupFeedback + ";\n";
          }
        });
        this.$refs.GrowthCulture.data5[0].expectDetails = allExpectDetails;
        this.$refs.GrowthCulture.data5[0].empDetails = allEmpDetails;
        this.$refs.GrowthCulture.data5[0].indirSupFeedback =
          allIndirSupFeedback;
        this.$refs.GrowthCulture.data5[0].dirSupFeedback = allDirSupFeedback;
      }
    },
    getApprovalData() {
      axios
        .post("/achReport/selectApprovalHistoryList ", {
          achStage: "阶段回顾",
          id: this.userInfoa.id,
          ...this.$refs.ApprovalHistory.pageInfo,
        })
        .then((res) => {
          this.$refs.ApprovalHistory.data = res.data;
          this.$refs.ApprovalHistory.total = parseInt(res.pageInfo.total);
        });
    },
    getOperationData() {
      axios
        .post("/achReport/selectOperationHistoryList", {
          achStage: "阶段回顾",
          id: this.userInfoa.id,
          ...this.$refs.OperationHistory.pageInfo,
        })
        .then((res) => {
          this.$refs.OperationHistory.data = res.data;
          this.$refs.OperationHistory.total = parseInt(res.pageInfo.total);
        });
    },
    pageChangeApproval(item) {
      this.getApprovalData();
    },
    pageChangeOperation(item) {
      this.getOperationData();
    },
    importCG() {
      this.$refs.cgTem.getInternation();
      //草稿type 操作人
      this.$refs.cgTem.popShow(
        "ACH01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      );
    },
    saveCG() {
      this.$refs.cgPop.getInternation();
      //草稿type 草稿内容
      let obj = {
        achKeyNoteInfoList: this.$refs.PersonalGoals.data1,
        stiTargetInfoList: this.$refs.STIComponent.data1,
        expectInfoList: this.$refs.BehaviorExpectation.data5,
        developmentPlanList: this.$refs.DevelopmentPlan.data5,
      };
      this.$refs.cgPop.popShow("ACH01", { formItem: obj });
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      this.spinShow = true;
      var obj = JSON.parse(row.draftContent);
      this.$refs.PersonalGoals.data1 = obj.formItem.achKeyNoteInfoList;
      this.$refs.PersonalGoals.tableSpan();
      this.$refs.STIComponent.data1 = obj.formItem.stiTargetInfoList;
      let list = obj.formItem.expectInfoList;
      let array = [];
      if (list.length > 0) {
        this.$refs.BehaviorExpectation.data5.forEach((element) => {
          list.forEach((item) => {
            if (element.criterionType == item.criterionType) {
              array.push({ ...element, ...item });
            }
          });
        });
        this.$refs.BehaviorExpectation.data5 = array;
      }
      this.$refs.DevelopmentPlan.data5 = obj.formItem.developmentPlanList;
      this.$nextTick(() => {
        setTimeout(() => {
          this.spinShow = false;
        }, 1000);
      });
    },
    submit() {
      this.userInfoa = { ...this.userInfoa, ...this.userInfo };
      let growthCultureList = JSON.parse(
        JSON.stringify(this.$refs.GrowthCulture.data5)
      );
      let growthCultureInfo1 = growthCultureList[0] || {};
      growthCultureList.map((item) => {
        item.expectDetails = growthCultureInfo1.expectDetails;
        item.empDetails = growthCultureInfo1.empDetails;
        item.indirSupFeedback = growthCultureInfo1.indirSupFeedback;
        item.dirSupFeedback = growthCultureInfo1.dirSupFeedback;
      });
      let obj = {
        achStage: "阶段回顾",
        createUser: JSON.parse(sessionStorage.getItem("userInfo")).serialnumber,
        applyAchInfo: {
          ...this.userInfoa,
          // serialnumber:this.userInfo.serialnumber,
          applyUserName: this.userInfoa.userName,
          beReport: "0",
          achTypeUser: this.userInfoa.achTypeUser,
        },
        achKeyNoteInfoList: this.$refs.PersonalGoals.data1,
        stiTargetInfoList: this.$refs.STIComponent.data1,
        expectInfoList: this.$refs.BehaviorExpectation.data5,
        developmentPlanList: this.$refs.DevelopmentPlan.data5,
        growthCultureList: growthCultureList,
      };
      this.spinShow = true;
      axios.post("/achApply/saveAchApplyInfo", obj).then((res) => {
        this.spinShow = false;
        if (res) {
          this.$Message.success(res);
        }
      });
    },
    returnApply() {
      this.$router.back();
    },
    QAClick() {
      this.$refs.qaComponent.QAModal = true;
      this.$refs.qaComponent.getUserList();
      this.qaId != "" ? (this.$refs.qaComponent.qaId = this.qaId) : "";
    },
    QAData(val) {
      this.qaId = val;
    },
    targetRevision() {
      if (this.targetUpdateButton != "1") {
        if (this.targetUpdateButton == "2") {
          this.$Message.info(this.$t("My_Performance_mess4"));
          return;
        } else {
          this.$Message.info(this.$t("My_Performance_mess5"));
          return;
        }
      }
      if (this.userInfoa.status < 2 || this.userInfoa.status == 90) {
        this.$Message.info(this.$t("My_Performance_mess6"));
        return;
      }
      if (this.userInfoa.status == 8 || this.userInfoa.status == 9) {
        this.$Message.info(this.$t("STIUpdateCheck"));
        return;
      }
      this.targetRevisionState = false;
      this.$emit("targetRevision", true);
    },
  },
};
</script>

<style lang="less" scoped>
.btnRight {
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  padding-bottom: 15px;
  left: 220px;
  z-index: 99;
  box-shadow: 0px -5px 10px -2px rgba(0, 0, 0, 0.2);
  .btn {
    margin-right: 15px;
    // margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/MidTermReview.vue